import type { ResponsePriceOverridesData } from "@classes-service-types/response-price-overrides-data.ts";

export const getPriceDifference = (data: ResponsePriceOverridesData) => {
  return (data?.override_amount_in_cents || 0) - (data.original_amount_in_cents || 0);
};
